import * as l from "../../../lib/littlejs.esm";
import { tilesize, tilesheets } from '../../const/tiles.ts';
import Enemy from './enemy.ts';
import Globals from "../../globals.ts";
/**
 * Simple bullet projectile entity
 */
class Bullet extends l.EngineObject {
    /**
     * @param {l.Vector2} pos - Starting position
     * @param {l.Vector2} direction - Direction vector
     */
    constructor(pos, direction) {
        super(pos, l.vec2(0.25, 0.25), l.tile(3, tilesize, tilesheets.ASSETS), 0, l.hsl(0.1, 1, 0.5));
        this.velocity = direction.normalize().multiply(l.vec2(0.1, 0.1));
        this.setCollision(true, true, true, false);
        this.mass = 0.1;
        this.gravityScale = 0;
    }
    /**
     * Update bullet movement and lifetime
     */
    update() {
        super.update();
        // Remove bullet after some time or if it goes off screen
        if (this.pos.x < 0 || this.pos.x > 40 || this.pos.y < 0 || this.pos.y > 16) {
            this.destroy();
        }
    }
    /**
     * Handle collision with player or solid objects
     * @param {l.EngineObject} object - Object collided with
     * @returns {boolean}
     */
    collideWithObject(object) {
        if (object === Globals.rex) {
            Globals.rex?.takeDamage(1, this.pos.copy());
            this.destroy();
        }
        else if (object !== Globals.chip && object instanceof ShootingEnemy === false) {
            // Destroy on collision with any solid object except Chip and other ShootingEnemies
            this.destroy();
        }
        return super.collideWithObject(object);
    }
}
/**
 * ShootingEnemy that detects Rex in line of sight and shoots projectiles
 */
class ShootingEnemy extends Enemy {
    /**
     * @param {l.Vector2} pos - Position of the enemy
     */
    constructor(pos) {
        super(pos, 4); // Use tile index 4 for enemy sprite
        this.shootCooldown = 0;
        this.shootCooldownMax = 300; // 5 seconds at 60fps
        this.detectionRange = 8;
        this.shootRange = 6;
    }
    /**
     * Update enemy behavior: detect Rex and shoot
     */
    update() {
        if (Globals.gameState == 'levelStart') {
            return;
        }
        super.update();
        // Only detect Rex, not Chip (due to size)
        if (!Globals.rex)
            return;
        const distanceToRex = this.pos.distance(Globals.rex.pos);
        // Check if Rex is within detection range
        if (distanceToRex <= this.detectionRange) {
            // Check line of sight using raycast (simple distance check for now)
            const directionToRex = Globals.rex.pos.subtract(this.pos).normalize();
            // For line of sight, we could implement raycasting, but for simplicity use distance
            // In a more complex implementation, check for obstacles between enemy and Rex
            const hasLineOfSight = distanceToRex <= this.shootRange;
            if (hasLineOfSight && this.shootCooldown <= 0) {
                this.shoot(directionToRex);
                this.shootCooldown = this.shootCooldownMax;
            }
        }
        // Update cooldown
        if (this.shootCooldown > 0) {
            this.shootCooldown--;
        }
    }
    /**
     * Shoot a bullet towards the target direction
     * @param {l.Vector2} direction - Direction to shoot
     */
    shoot(direction) {
        const bulletPos = this.pos.add(direction.multiply(l.vec2(0.5, 0.5)));
        new Bullet(bulletPos, direction);
    }
}
export default ShootingEnemy;
